export enum QuelleTyp {
    STALL = 1,
    FLAECHE = 2,
    SONSTIGE = 3,
  }
  